import { getApiURL, getSessionId } from 'utils/utils';
import axios from 'axios';

const instance = axios.create({
  // baseURL: 'http://localhost:9781',
  baseURL: getApiURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});
export const listMyCycles = () =>
  instance.post(`/web-app/user/cycles/list`, undefined, {
    headers: {
      sessionId: getSessionId(),
    },
  });

//get-by-id
export const getMyCycleById = (params) =>
  instance.post(`/web-app/user/cycles/get-by-id`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });
